import React from 'react';
import PropTypes from 'prop-types';

// Import assets
import './newsletterTile.scss';

const NewsletterTileView = props => (
  <a className="m-tile m-tile--medium m-tile--newsletter" target={'_blank'} rel="noopener" href={props.buttonTarget}>
    <div className="m-tile__inner">
      <div className="m-tile__content">
        <div className={'m-tile__headline'}>{props.headline}</div>
        <div className={'m-tile__copy'}>{props.copy}</div>
        <span className="a-button a-button--blue a-button--large" >
          {props.buttonLabel}
        </span>
      </div>
    </div>
  </a>
);

NewsletterTileView.propTypes = {
  headline: PropTypes.string,
  copy: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonTarget: PropTypes.string,
};

NewsletterTileView.defaultProps = {
  headline: '',
  copy: '',
  buttonLabel: '',
  buttonTarget: '',
};

export default NewsletterTileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/NewsletterTile/NewsletterTileView.jsx